import { useTranslation } from "react-i18next";
import { Button } from "../../../booking/ui/shared/components/Buttons";
import { useDispatch, useSelector } from "react-redux";
import { submitForgotPassword } from '../data/account/actions/forgotPassword';
import { showSignIn } from "../data/account/actions/signInModal";

export default function ForgotPassword() {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const { email } = useSelector(state => state.account.signInModal);
    const { isLoading } = useSelector(state => state.account.forgotPassword);

    const handleSendEmail = () => {
        let values = {};
        values["email"] = email;
        dispatch(submitForgotPassword(values));
    }

    return (
        <div className={"space-y-4 flex flex-col max-w-[400px] text-justify"}>
            <h2 className="text-xl font-bold !m-0">{t('account_button.forgot_password')}</h2>
            <div className='self-start flex items-center gap-2'>
                <Button onClick={() => {dispatch(showSignIn(email))}} icon={"long-arrow-left"} className={"w-6 h-6 flex justify-center items-center bg-gray-200 hover:bg-gray-400 rounded-full"}/>
                <p>{email}</p>
            </div>
            <div className="mb-4">
                {`${t('account_button.send_confirmation_mail_to_1')} ${email ? email : ""} ${t('account_button.send_confirmation_mail_to_2')}`}
            </div>
            <div className="flex justify-center">
                <Button
                    onClick={handleSendEmail}
                    type="submit"
                    icon={"paper-plane"}
                    loading={isLoading}
                    className="p-3 rounded-md bg-orange-500 text-white hover:bg-orange-500"
                >
                    {t('account_button.send_email')}
                </Button>
            </div>
        </div>
    )
}